<template>
  <div>
    <page-header
      title="Process Transload"
      breadcrumb="Dashboard > Booking & Shipments > Process Transload"
    />
    <div class="card">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-4">
            <label for="fname" class="label">Shipping/Dispatch Ref</label>
            <input
              type="text"
              class="input"
              placeholder="Auto-loaded from existing shipment"
            />
          </div>
          <div class="col-md-4">
            <label for="mname" class="label">Fleet Type</label>
            <input
              type="text"
              class="input"
              placeholder="Auto-loaded from existing shipment"
            />
          </div>
          <div class="col-md-4">
            <label for="lname" class="label">Fleet ID</label>
            <input
              type="text"
              class="input"
              placeholder="-- Enter Last Name --"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <label for="gender" class="label">Fleet Name</label>
            <input type="text" class="input" />
          </div>
          <div class="col-md-4">
            <label for="email" class="label">Driver</label>
            <input type="email" class="input" />
          </div>
          <div class="col-md-4">
            <label for="number" class="label">Contact Number</label>
            <vue-tel-input></vue-tel-input>
          </div>
        </div>
        <hr class="my-4"/>
        <div class="row">
          <div class="col-md-4 col-lg-4 col-12">
            <label for="employment-type" class="label">Origin (From)</label>
            <el-select placeholder=""> </el-select>
          </div>
          <div class="col-md-4 col-lg-4 col-12">
            <label for="role" class="label">Designation (To)</label>
            <base-input></base-input>
          </div>
          <div class="col-md-4 col-lg-4 col-12">
            <label for="role" class="label">Designation (To)</label>
            <input
              type="text"
              class="input"
              placeholder="Auto-loaded from Designation"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 col-lg-4 col-12">
            <label for="employment-type" class="label">Contact Person</label>
            <input
              type="text"
              class="input"
              placeholder="Auto-loaded from Designation"
            />
          </div>
          <div class="col-md-4 col-lg-4">
            <label for="role" class="label">Contact's Mobile</label>
             <base-input
                placeholder="Enter Your Email"
                errorText="Please enter a valid email Address"
              >
                <template v-slot:icon-right>
                  <img src="@/assets/images/icons/edit.svg" alt="">
                </template>
              </base-input>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label for="comments" class="label">Comments</label>
            <textarea name="" id="comments" cols="30" rows="30" class="input"></textarea>
          </div>
        </div>
        <hr class="my-4">
        <div class="">
          <h3 class="font-bold">Transload Process</h3>
          <p class="my-2">Select your desired tranload Process</p>
          <div class="row bg-gray-100 p-4">
            <div class="col-md-4 flex gap-4 cursor-pointer p-2 hover:bg-white hover:shadow-md hover:rounded-lg" @click="$router.push({ name: 'IncidentTransloadAndDeliver'})">
              <span>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="24" height="24" fill="white"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M3 4C2.44772 4 2 4.44772 2 5C2 5.55228 2.44772 6 3 6H12V11V16H9.82929C9.41746 14.8348 8.30622 14 7 14C5.69378 14 4.58254 14.8348 4.17071 16H4V15V13C4 12.4477 3.55228 12 3 12C2.44772 12 2 12.4477 2 13V15V17C2 17.5523 2.44772 18 3 18H4.17071C4.58254 19.1652 5.69378 20 7 20C8.30622 20 9.41746 19.1652 9.82929 18H13H14.1707C14.5825 19.1652 15.6938 20 17 20C18.3062 20 19.4175 19.1652 19.8293 18H21C21.5523 18 22 17.5523 22 17V11C22 10.8188 21.9507 10.6409 21.8575 10.4855L18.8575 5.4855C18.6768 5.1843 18.3513 5 18 5H14C14 4.44772 13.5523 4 13 4H3ZM19.8293 16H20V12H14V16H14.1707C14.5825 14.8348 15.6938 14 17 14C18.3062 14 19.4175 14.8348 19.8293 16ZM16 17C16 16.4477 16.4477 16 17 16C17.5523 16 18 16.4477 18 17C18 17.5523 17.5523 18 17 18C16.4477 18 16 17.5523 16 17ZM6 17C6 17.5523 6.44772 18 7 18C7.55228 18 8 17.5523 8 17C8 16.4477 7.55228 16 7 16C6.44772 16 6 16.4477 6 17ZM14 10V7H17.4338L19.2338 10H14ZM6 11.8868L11 9L6 6.11325V8H5H1H0V10H1H5H6V11.8868Z" fill="#FCC210"/>
                </svg>
              </span>
              <div class="flex flex-col gap-2">
                <h3>Transload & Deliver</h3>
                <p>Assign packages to another vehicle. Maintain original destination.</p>
              </div>
            </div>
            <div class="col-md-4 flex gap-4 cursor-pointer p-2 hover:bg-white hover:shadow-md hover:rounded-lg"  @click="$router.push({ name: 'IncidentTransloadAndReturnToBase'})">
              <span>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="24" height="24" fill="white"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M3 4C2.44772 4 2 4.44772 2 5C2 5.55228 2.44772 6 3 6H12V11V16H9.82929C9.41746 14.8348 8.30622 14 7 14C5.69378 14 4.58254 14.8348 4.17071 16H4V15V13C4 12.4477 3.55228 12 3 12C2.44772 12 2 12.4477 2 13V15V17C2 17.5523 2.44772 18 3 18H4.17071C4.58254 19.1652 5.69378 20 7 20C8.30622 20 9.41746 19.1652 9.82929 18H13H14.1707C14.5825 19.1652 15.6938 20 17 20C18.3062 20 19.4175 19.1652 19.8293 18H21C21.5523 18 22 17.5523 22 17V11C22 10.8188 21.9507 10.6409 21.8575 10.4855L18.8575 5.4855C18.6768 5.1843 18.3513 5 18 5H14C14 4.44772 13.5523 4 13 4H3ZM19.8293 16H20V12H14V16H14.1707C14.5825 14.8348 15.6938 14 17 14C18.3062 14 19.4175 14.8348 19.8293 16ZM16 17C16 16.4477 16.4477 16 17 16C17.5523 16 18 16.4477 18 17C18 17.5523 17.5523 18 17 18C16.4477 18 16 17.5523 16 17ZM6 17C6 17.5523 6.44772 18 7 18C7.55228 18 8 17.5523 8 17C8 16.4477 7.55228 16 7 16C6.44772 16 6 16.4477 6 17ZM14 10V7H17.4338L19.2338 10H14ZM6 11.8868L11 9L6 6.11325V8H5H1H0V10H1H5H6V11.8868Z" fill="#FCC210"/>
                </svg>
              </span>
              <div class="flex flex-col gap-2">
                <h3>Transload & Return to Base </h3>
                <p>Assign packages to another vehicle. Return packages to point of pickup.</p>
              </div>
            </div>
            <div class="col-md-4 flex gap-4 cursor-pointer p-2 hover:bg-white hover:shadow-md hover:rounded-lg"  @click="$router.push({ name: 'IncidentSplitTransloadAndDeliver'})">
              <span>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="24" height="24" fill="white"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M3 4C2.44772 4 2 4.44772 2 5C2 5.55228 2.44772 6 3 6H12V11V16H9.82929C9.41746 14.8348 8.30622 14 7 14C5.69378 14 4.58254 14.8348 4.17071 16H4V15V13C4 12.4477 3.55228 12 3 12C2.44772 12 2 12.4477 2 13V15V17C2 17.5523 2.44772 18 3 18H4.17071C4.58254 19.1652 5.69378 20 7 20C8.30622 20 9.41746 19.1652 9.82929 18H13H14.1707C14.5825 19.1652 15.6938 20 17 20C18.3062 20 19.4175 19.1652 19.8293 18H21C21.5523 18 22 17.5523 22 17V11C22 10.8188 21.9507 10.6409 21.8575 10.4855L18.8575 5.4855C18.6768 5.1843 18.3513 5 18 5H14C14 4.44772 13.5523 4 13 4H3ZM19.8293 16H20V12H14V16H14.1707C14.5825 14.8348 15.6938 14 17 14C18.3062 14 19.4175 14.8348 19.8293 16ZM16 17C16 16.4477 16.4477 16 17 16C17.5523 16 18 16.4477 18 17C18 17.5523 17.5523 18 17 18C16.4477 18 16 17.5523 16 17ZM6 17C6 17.5523 6.44772 18 7 18C7.55228 18 8 17.5523 8 17C8 16.4477 7.55228 16 7 16C6.44772 16 6 16.4477 6 17ZM14 10V7H17.4338L19.2338 10H14ZM6 11.8868L11 9L6 6.11325V8H5H1H0V10H1H5H6V11.8868Z" fill="#FCC210"/>
                </svg>
              </span>
              <div class="flex flex-col gap-2">
                <h3>Split Transload & Deliver</h3>
                <p>Split packages to be delivered to different destinations.</p>
              </div>
            </div>
          </div>
        </div>
        <hr class="my-4">
        <div class="flex items-center justify-between">
          <div class="cursor-pointer" @click="$router.go(-1)">
            <p>Cancel</p>
          </div>
          <primary-button buttonText="continue" />
        </div>
      </div>
    </div>
  </div>
</template> 

<script>
import PageHeader from "@/components/UI/NewPageHeader";

export default {
  components: {
    PageHeader,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.tab-item {
  cursor: pointer;
  // margin-right: 1rem;
  color: #5e646d;
  padding: 0.25rem 1.5rem;
  font-size: 0.9rem;
  &.active {
    background: #ffffff;
    box-shadow: 0px 4px 10px rgba(17, 21, 25, 0.1);
    border-radius: 5px;
    color: #fcc210;
    font-weight: bold;
  }
}
</style>